<template>
  <v-card outlined class="mb-6">
    <div class="d-flex justify-space-between align-items-center py-6 pl-6">
      <h5 class="text-uppercase align-self-center">Thông tin quan tâm ban đầu</h5>
    </div>
    <v-row class="px-6" no-gutters>
      <v-col cols="6">
        <p class="grey--text mb-0 mt-0">Hình thức theo học</p>
        <p class="mt-0 mb-6">{{ studentLearningMethods }}</p>
      </v-col>
      <v-col cols="6">
        <p class="grey--text mb-0 mt-0">Trường dự định thi</p>
        <p class="mt-0 mb-6">{{ profile.expectSchool }}</p>
      </v-col>
      <v-col cols="6">
        <p class="grey--text mb-0 mt-0">Khóa học muốn tham gia</p>
        <p class="mt-0 mb-6" v-html="studentProducts"></p>
      </v-col>
      <v-col cols="6">
        <p class="grey--text mb-0 mt-0">Cơ sở đăng ký</p>
        <p class="mt-0 mb-6" v-html="studentDepartments"></p>
      </v-col>
    </v-row>
  </v-card>
</template>
<script>
import { mapGetters } from 'vuex'
import { displayDataInConfigs, CONFIG_KEYS } from '../helpers'
import get from 'lodash-es/get'
export default {
  computed: {
    ...mapGetters({ profile: 'lead/item', configs: 'leadConfig/configs' }),
    studentLearningMethods() {
      const data = get(this.profile, 'studentLearningMethods', [])
      if (Array.isArray(data) && data.length)
        return displayDataInConfigs({
          configs: this.configs,
          type: CONFIG_KEYS.STUDENT_LEARNING_METHOD,
          separator: ', ',
          valuePrefix: '',
          data,
        })
      return '--'
    },
    studentProducts() {
      const data = get(this.profile, 'studentProducts', [])
      if (Array.isArray(data) && data.length)
        return displayDataInConfigs({ configs: this.configs, type: CONFIG_KEYS.STUDENT_PRODUCT, data })
      return '--'
    },
    studentDepartments() {
      const data = get(this.profile, 'studentDepartments', [])
      if (Array.isArray(data) && data.length)
        return displayDataInConfigs({ configs: this.configs, type: CONFIG_KEYS.STUDENT_DEPARTMENT, data })
      return '--'
    },
  },
}
</script>